const UploadTypes = {
  EditRequestSignature: 'edit-request-signature',
  EditSign: 'edit-sign',
  FreeWrite: 'free-write',
  Rearrange: 'rearrange',
  Template: 'template',
};

export default UploadTypes;



// WEBPACK FOOTER //
// ./src-react/Upload/UploadTypes.jsx